import type { LineWithEntities } from '@/types';
import type { LineOutrightWithEntities } from './GroupedLines.types';
export const groupLines = <T extends LineWithEntities | LineOutrightWithEntities,>(list: Array<T>, groupBy?: 'sport' | 'championship'): Map<string, Array<T>> => {
  return list.reduce<Map<string, Array<T>>>((groups, item) => {
    let groupKey = 'stage' in item ? `${item.championshipId}-${item.categoryId}-${item.stage}` : '';
    if (groupBy === 'sport') {
      groupKey = `${item.sportId}`;
    }
    if (groupBy === 'championship') {
      groupKey = `${item.championshipId}`;
    }
    const group = (groups.get(groupKey) as Array<T>) || [];
    group.push(item);
    groups.set(groupKey, group);
    return groups;
  }, new Map());
};